import { isLogtoRequestErrorJson, LogtoError, LogtoRequestError } from '@logto/js';

/**
 * A factory function that creates a requester by accepting a `fetch`-like function.
 *
 * @param fetchFunction A `fetch`-like function.
 * @returns A requester function.
 * @see {@link Requester}
 */
const createRequester = (fetchFunction) => {
    return async (...args) => {
        const response = await fetchFunction(...args);
        if (!response.ok) {
            const cloned = response.clone();
            const responseJson = await response.json();
            console.error(`Logto requester error: [status=${response.status}]`, responseJson);
            if (!isLogtoRequestErrorJson(responseJson)) {
                throw new LogtoError('unexpected_response_error', responseJson);
            }
            // Expected request error from server
            const { code, message } = responseJson;
            throw new LogtoRequestError(code, message, cloned);
        }
        return response.json();
    };
};

export { createRequester };
